import { createTheme } from '@mui/material/styles';

export const miracleTheme = createTheme({
    // 1. Les Couleurs (Identité Miracle Travel)
    palette: {
        primary: {
            main: '#c9a84c', // Ton Gold principal
            light: '#e8d5a3',
            dark: '#967a33',
            contrastText: '#faf7f2', // Texte Cream sur fond Gold
        },
        secondary: {
            main: '#1a1a2e', // Ton Ink principal
            dark: '#050509',
        },
        background: {
            default: '#faf7f2', // Fond Cream global
            paper: '#ffffff',
        },
        text: {
            primary: '#1a1a2e',
            secondary: '#757584',
        },
        divider: 'rgba(201, 168, 76, 0.15)', // Lignes de séparation Gold très fines
    },

    // 2. Typographie (Cormorant pour le prestige, DM Sans pour le code/données)
    typography: {
        fontFamily: "'DM Sans', sans-serif",
        h1: {
            fontFamily: "'Cormorant Garamond', serif",
            fontWeight: 600,
            fontSize: '2.25rem',
        },
        h2: {
            fontFamily: "'Cormorant Garamond', serif",
            fontWeight: 600,
            fontSize: '1.75rem',
        },
        h6: {
            fontWeight: 700,
            fontSize: '0.9rem',
            letterSpacing: '0.05em',
        },
        button: {
            textTransform: 'none', // Pas de majuscules forcées sur les boutons
            fontWeight: 600,
        },
    },

    // 3. Arrondis et Ombres
    shape: {
        borderRadius: 10,
    },
    shadows: [
        'none',
        '0 1px 3px rgba(26, 26, 46, 0.05)', // sm
        '0 4px 12px rgba(26, 26, 46, 0.08)', // md
        ...Array(22).fill('none'), // MUI a besoin de 25 niveaux d'ombres
    ],

    // 4. Surcharge des composants (Overrides)
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    padding: '8px 20px',
                    transition: 'all 0.2s ease-in-out',
                    '&:hover': {
                        transform: 'translateY(-1px)',
                        boxShadow: '0 4px 8px rgba(201, 168, 76, 0.2)',
                    },
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none', // Supprime le filtre gris de MUI en mode sombre
                },
            },
        },
        MuiCard: {
            defaultProps: {
                variant: 'outlined', // Look plus épuré que le mode "shadow"
            },
            styleOverrides: {
                root: {
                    padding: '24px',
                    borderColor: 'rgba(201, 168, 76, 0.15)',
                },
            },
        },
    },
});